var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g({attrs:{"small":"","flat":"","color":"primary"}},_vm.$listeners),[_vm._v("\n  Применить\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }